import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export function IosShareIcon(props) {
    return (
        <SvgIcon {...props}>
            <polygon points="13.8 6.46 13.8 7.384 20.1 7.384 20.1 23.077 3.9 23.077 3.9 7.384 10.2 7.384 10.2 6.46 3 6.46 3 24 21 24 21 6.46 13.8 6.46"/><polygon points="11.539 1.812 11.539 15.833 12.461 15.833 12.461 1.812 15.539 4.967 16.191 4.298 12 0 7.809 4.298 8.461 4.967 11.539 1.812"/>
        </SvgIcon>
    );
}